import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import sortWidgets from '../../common/utils/sortWidgets';
export default class BottomWidgetSection extends Component {
  view() {
    if (!app.widgets.onWidgetPage()) return null;
    if (!app.widgets.get('bottom').length) return null;
    return m("div", {
      className: "container"
    }, m("div", {
      className: "FofWidgets-bottomWidgetSection FofWidgets-WidgetSection"
    }, sortWidgets(app.widgets.get('bottom')).map(widget => widget.component.component({
      state: widget.state
    }))));
  }
}
flarum.reg.add('fof-forum-widgets-core', 'forum/components/BottomWidgetSection', BottomWidgetSection);